import classNames from "classnames";
import React from "react";
import "./buttonControl.scss";

interface ButtonControlProps {
  value: string;
  type: "button" | "submit";
  onClick?: () => void;
  className?: string;
  testId?: string;
  disabled?: boolean;
  hidden?: boolean;
  full?: boolean;
  primary?: boolean;
  danger?: boolean;
  link?: boolean;
  goback?: boolean;
  outline?: boolean;
  add?: boolean;
}

export const ButtonControl = (props: React.PropsWithChildren<ButtonControlProps>) => {
  return (
    <input
      type={props.type}
      value={props.value}
      onClick={props?.onClick}
      className={classNames(props.className, {
        "buttonControl": true,
        "full": props.full,
        "primary": props.primary,
        "danger": props.danger,
        "outline": props.outline,
        "goback": props.goback,
        "add": props.add,
      })}
      data-testid={props?.testId ?? "button-test"}
      disabled={props?.disabled}
      hidden={props?.hidden}
    />
  );
};